import { render, staticRenderFns } from "./FullRolodexEntry.vue?vue&type=template&id=1fea81ba&scoped=true&"
import script from "./FullRolodexEntry.vue?vue&type=script&lang=ts&"
export * from "./FullRolodexEntry.vue?vue&type=script&lang=ts&"
import style0 from "./FullRolodexEntry.vue?vue&type=style&index=0&id=1fea81ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fea81ba",
  null
  
)

export default component.exports